import { staffStrings } from '@data/staff';
import { PaginationType } from '@models/next/PaginationType';
import { z } from 'zod';

export const Staff = z.object({
  id: z.number(),
  staff_id: z.string().label(staffStrings.staff_id),
  display_name: z.string().label(staffStrings.name),
  first_name: z.string().label(staffStrings.first_name),
  last_name: z.string().label(staffStrings.last_name),
  avatar_url: z.string().nullish(),
  role: z.string().label(staffStrings.role),
  email: z.string().label(staffStrings.email),
  agency_id: z.number().nullish(),
  last_login: z.string().nullish(),
});

export type Staff = z.infer<typeof Staff>;

export const StaffSearchQuery = z
  .object({
    page: PaginationType.shape.page,
    page_size: PaginationType.shape.page_size,
    email: Staff.shape.email,
    display_name: Staff.shape.display_name,
    staff_id: Staff.shape.staff_id,
    role: Staff.shape.role,
    agency_id: Staff.shape.agency_id,
  })
  .partial();

export type StaffSearchQuery = z.infer<typeof StaffSearchQuery>;

export const StaffPages = z.object({
  count: z.number(),
  results: z.array(Staff),
});

export type StaffPages = z.infer<typeof StaffPages>;
